import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ConfigService, IntlService, KwkService, TrackingService } from 'services'
import { Form, InfoButton } from 'ui'
import FormChallenge from '../misc/FormChallenge'

export default function KwkForm({ dataPrivacyUrl, successUrl }) {
  const [fieldErrors, setFieldErrors] = useState([])

  const productOptions = ConfigService.get('kwk.products').map(value => ({
    value,
    label: IntlService.get(`kwk.product.${value}`)
  }))
  const subjectOptions = ConfigService.get('kwk.subjects').map(value => ({
    value,
    label: IntlService.get(`kwk.subject.${value}`)
  }))
  const titleOptions = ConfigService.get('kwk.titles').map(value => ({
    value,
    label: IntlService.get(`kwk.title.${value}`)
  }))

  const onSubmit = (e, { data }) => {
    TrackingService.trackGenericEvent('kwkSubmit')

    if (data.emailIdReferral === data.emailIdCustomer) {
      setFieldErrors([
        {
          fieldName: 'emailIdReferral',
          errorMessage: 'E-Mails müssen unterschiedlich sein'
        }
      ])
      return false
    }

    KwkService.send(data)
      .then(() => {
        window.location.href = successUrl || window.location.href
      })
      .catch(e => {
        if (e && e.fieldErrors) {
          setFieldErrors(e.fieldErrors)
        } else {
          console.error(e)
        }
      })

    return false
  }

  return (
    <Form fieldErrors={fieldErrors} method="POST" onSubmit={onSubmit} noAction>
      <Form.Row className="mb-1">
        <Form.Col>
          <Form.Group className="mb-2" title="Produktauswahl und Betreffzeile">
            <Form.Row className="mb-1">
              <Form.Col className="d-flex">
                <Form.Select
                  className="col-12 d-block p-0"
                  name="productArea"
                  placeholder="Wählen Sie ein Produkt*"
                  options={productOptions}
                  required
                />
              </Form.Col>
            </Form.Row>

            <Form.Row className="mb-1">
              <Form.Col className="d-flex">
                <Form.Select
                  className="me-1"
                  name="emailSubject"
                  placeholder="Wählen Sie eine Betreffzeile*"
                  options={subjectOptions}
                  full
                  required
                />
                <InfoButton
                  className="mb-0 btn--info"
                  text="Geben Sie hier an, welcher Betreff in der generierten E-Mail stehen soll."
                />
              </Form.Col>
            </Form.Row>
          </Form.Group>

          <Form.Group className="mb-2" title="Angaben zum Empfänger Ihrer Empfehlung">
            <Form.Row className="mb-1">
              <Form.Col>
                <Form.Select
                  className="col-12 d-block p-0"
                  name="titleReferral"
                  placeholder="Anrede*"
                  options={titleOptions}
                  required
                />
              </Form.Col>
            </Form.Row>
            <Form.Row className="mb-1">
              <Form.Col className="col-md-6 mb-1 mb-md-0">
                <Form.Input name="firstNameReferral" placeholder="Vorname*" required />
              </Form.Col>
              <Form.Col className="col-md-6">
                <Form.Input name="lastNameReferral" placeholder="Nachname*" required />
              </Form.Col>
            </Form.Row>
            <Form.Row className="mb-1">
              <Form.Col>
                <Form.Input
                  name="emailIdReferral"
                  type="email"
                  pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  placeholder="E-Mail-Adresse*"
                  required
                />
              </Form.Col>
            </Form.Row>
          </Form.Group>

          <Form.Group className="mb-2" title="Ihre persönlichen Angaben">
            <Form.Row className="mb-1">
              <Form.Col className="col-md-6 mb-1 mb-md-0">
                <Form.Input name="firstNameCustomer" placeholder="Vorname*" required />
              </Form.Col>
              <Form.Col className="col-md-6">
                <Form.Input name="lastNameCustomer" placeholder="Nachname*" required />
              </Form.Col>
            </Form.Row>
            <Form.Row className="mb-1">
              <Form.Col>
                <Form.Input
                  name="emailIdCustomer"
                  type="email"
                  pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  placeholder="E-Mail-Adresse*"
                  required
                />
              </Form.Col>
            </Form.Row>
            <Form.Row className="mb-1">
              <Form.Col className="d-flex">
                <Form.Input
                  className="me-1"
                  name="customerNumber"
                  pattern="\d+"
                  placeholder="Kundennummer*"
                  defaultValue={KwkService.customerNumber}
                  required
                />
                <InfoButton
                  className="mb-0 btn--info"
                  text="Wenn Sie hier Ihre 1&1 Kundennummer angeben, wird der vermittelte Vertrag Ihnen zugeordnet und die Geldprämie automatisch ausgezahlt."
                />
              </Form.Col>
            </Form.Row>
          </Form.Group>

          <FormChallenge />

          <Form.Row className="mb-1">
            <Form.Col>
              <small>* Pflichtfelder müssen ausgefüllt werden.</small>
            </Form.Col>
          </Form.Row>
          <Form.Row className="mb-2">
            <Form.Col>
              <a href={dataPrivacyUrl} target="_blank" rel="noopener noreferrer">
                <span className="link__text">
                  <span>Hinweise zum Datenschutz</span>
                </span>
              </a>
            </Form.Col>
          </Form.Row>
        </Form.Col>
      </Form.Row>
      <Form.Button type="submit" icon="arrow" text="Senden" primary />
    </Form>
  )
}

KwkForm.propTypes = {
  dataPrivacyUrl: PropTypes.string,
  successUrl: PropTypes.string
}

KwkForm.defaultProps = {
  dataPrivacyUrl: '#Datenschutz',
  successUrl: '#Versendet'
}
